/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
import moment from 'moment';
import numeral from 'numeral';
// import numeral from 'numeral';

/* eslint-disable radix */
/* eslint-disable array-callback-return */
const isJSON = (text) => {
  try {
    const obj = JSON.parse(text);
    return obj === Object(obj) && Object.prototype.toString.call(obj) !== '[object Array]';
  } catch (error) {
    return false;
  }
};

// convert object to array, preserve the keys
const toArray = obj => Object.keys(obj).map(key => ({ key, value: obj[key] }));

const locale = currentLocale => (currentLocale === 'EN' ? 'عربي' : 'EN');

const stringBuilder = (obj) => {
  let result = '';
  Object.keys(obj).map((key, index) => {
    if (obj[key] && obj[key] !== '' && index < Object.keys(obj).length - 1) {
      result += `${[key]}=${obj[key]};`;
    } else if (obj[key] && obj[key] !== '' && index === Object.keys(obj).length - 1) {
      result += `${[key]}=${obj[key]}`;
    }
  });
  return result;
};

const yearBuilder = (str, option) => {
  const n = parseInt(str);
  if (n === 1) {
    return `${n} ${option.singular}`;
  } if (n > 1) {
    return `${n} ${option.plural}`;
  }
  return str;
};

const formatDecimalToPercentage = (value) => {
  const percentage = Number(value) * 100;
  return `${parseInt(percentage)} %`;
};

const formatDate = date => moment(date).locale('en').format('D MMM YYYY');
const formatDateToYears = date => moment(date).locale('en').format('YYYY');

/**
 * is app running as PWA
 */
const isInStandaloneMode = () => (window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://');

const formatNumber = (value) => {
  if (Number.isNaN(parseFloat(value))) return '';
  return new Intl.NumberFormat('en', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

/**
 * format NAV/Unit
 * @param {*} value
 */
const formatNavUnit = (value) => {
  if (Number.isNaN(parseFloat(value))) return '';
  return new Intl.NumberFormat('en', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

const format3yPerformance = value => (value <= 0 ? `${formatNavUnit(value)} %` : `+ ${formatNavUnit(value)} %`);

/**
 * format net assets
 * @param {*} value
 */
const formatUnitCurrency = (value, currency) => {
  if (value && !Number(value) <= 0) {
    return Math.abs(Number(value)) >= 1.0e+9 ? `${currency} ${formatNumber(Number(value) / 1.0e+9)} bil.`
      : Math.abs(Number(value)) >= 1.0e+8 ? `${currency} ${formatNumber(Number(value) / 1.0e+8)} bil.`
        : Math.abs(Number(value)) >= 1.0e+7 ? `${currency} ${formatNumber(Number(value) / 1.0e+7)} bil.`
          : Math.abs(Number(value)) >= 1.0e+6 ? `${currency} ${formatNumber(Number(value) / 1.0e+6)} bil.`
            : `${currency} ${formatNumber(value)}`;
  }
  if (Number(value) <= 0 || !Number(value)) {
    return '-';
  }
};

const selectApplication = (applicationVia) => {
  switch (applicationVia) {
    case 'email_forms':
      return 'Open Account Later';
    case 'go_to_cob':
      return 'Open Account Now';
    default:
      return 'Open Account';
  }
};


const selectCTA = (cta, applicationVia) => {
  switch (cta) {
    case 'meet_advisor':
      return 'Appointment';
    case 'open_account':
      return selectApplication(applicationVia);
    case 'email_product':
      return 'Email Simulation';
    default:
      return '';
  }
};

const handleCompleteProspect = (refCode, summary, intl, tracking, rating, trackCompleteProspect) => {
  const initialInvestment = numeral(summary['summary.initialInvestment']).value();
  const isRetail = initialInvestment >= 5000 && initialInvestment <= 99999;
  const isAffluent = initialInvestment >= 100000 && initialInvestment <= 250000;
  const body = {
    refCode,
    // refCode: '27102020-156782',
    name: summary['summary.name'],
    phone: summary['summary.phone'],
    email: summary['summary.email'],
    age: summary['summary.age'].split(' Year')[0],
    assets: summary['summary.targetAmount'],
    investableAsset: summary['summary.initialInvestment'] || '',
    goal: intl.formatMessage({ id: summary['summary.goal'] }),
    risk: intl.formatMessage({ id: summary['summary.risk'] }),
    // cma: intl.formatMessage({ id: summary['summary.regulatoryClassification'] }, { textQualified: 'no', textRetail: 'no' })
    //   .split(' ')[1]
    //   .split('Investor')[0],
    // eslint-disable-next-line no-nested-ternary
    clientSegment: isRetail ? 'retail' : isAffluent ? 'affluent' : 'private',
    dateTime: `${moment().locale('en').format('DD/MM/YY')}, ${moment().format('HH:mm')}`,
    cta: selectCTA(summary['summary.proceedOption'], summary['summary.applicationVia']),
    rating,
  };
  trackCompleteProspect(tracking, body);
};

const ultilitiesService = {
  isJSON,
  toArray,
  locale,
  stringBuilder,
  yearBuilder,
  formatDate,
  formatDateToYears,
  formatDecimalToPercentage,
  isInStandaloneMode,
  formatNumber,
  formatUnitCurrency,
  formatNavUnit,
  format3yPerformance,
  handleCompleteProspect,
};

export default ultilitiesService;
